export const SOLES = 1;
export const DOLARES_AMERICANOS = 2;